export const responseMapperErrors = {
  RESPONSE_MAPPER_EXCEPTION: {
    status: 500,
    code: 'RESPONSE_MAPPER_EXCEPTION',
    title: 'Error Processing Response',
    subtitle: 'RESPONSE ERROR',
    description: 'This error is caused by an issue with the app’s internal configuration. Since apps are managed by MindCloud, please report this issue through the designated support channels for assistance.',
    roles: {
      admin: {
        title: 'Response Mapper Error',
        subtitle: 'RESPONSE MAPPER ERROR',
        description: 'There was an issue processing the response using the Response Mapper for this API. Please review the mapper logic and ensure it is configured correctly.',
        about: {
          title: 'More on this error',
          description: 'This error occurs when the system encounters a problem with the Response Mapper during the response processing phase. The Response Mapper standardizes the data returned from the API to ensure it matches MindCloud’s expected format. Please review the Response Mapper setup to resolve this issue.',
          link: { text: 'Learn More', url: 'https://mindcloud.co/docs/gravity/app-guides/apis/rest-apis/response-mappers' }
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  API_RESPONSE_MAPPER_MISSING_PROPERTIES: {
    status: 500,
    code: 'API_RESPONSE_MAPPER_MISSING_PROPERTIES',
    title: 'Error Processing Response',
    subtitle: 'RESPONSE ERROR',
    description: 'This error is caused by an issue with the app’s internal configuration. Since apps are managed by MindCloud, please report this issue through the designated support channels for assistance.',
    roles: {
      admin: {
        title: 'Invalid Response Mapper',
        subtitle: 'APP ERROR',
        description: "This step's output is missing one or more of the required properties (`success`, `data`, `meta`). The Response Mapper for this API needs to be corrected to ensure these properties are included.",
        about: {
          title: 'More on this error',
          description: 'This error occurs when the response from the API is missing required properties. A valid API response should always contain `success`, `data`, and `meta`. The `meta` property itself is mandatory, but its contents are flexible depending on the API. Please review the Response Mapper to ensure it includes these properties.',
          link: { text: 'Learn More', url: 'https://mindcloud.document360.io/docs/gravity-standard-response-format' }
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  API_RESPONSE_MAPPER_INVALID_DATA_FORMAT: {
    status: 500,
    code: 'API_RESPONSE_MAPPER_INVALID_DATA_FORMAT',
    title: 'Error Processing Response',
    subtitle: 'RESPONSE ERROR',
    description: 'This error is caused by an issue with the app’s internal configuration. Since apps are managed by MindCloud, please report this issue through the designated support channels for assistance.',
    roles: {
      admin: {
        title: 'Invalid Output Format',
        subtitle: 'APP ERROR',
        description: 'This step has returned data in an unexpected format. This indicates that the Response Mapper for this API may not be handling the data correctly and needs to be reviewed.',
        about: {
          title: 'More on this error',
          description: 'This error occurs when the response from an API does not match the expected format required by the App. The Response Mapper is responsible for transforming the response so it adheres to MindCloud’s standard formatting. In this case, the mapper may need to be corrected to handle the data properly.',
          link: { text: 'Learn More', url: 'https://mindcloud.document360.io/docs/gravity-standard-response-format' }
        }
      }
    },
    component: 'DefaultErrorPage'
  }
};
